import * as Types from '../graphQlTypes.generated';

import { graphQlService } from '@doxyme/frontend/services/graphql.service';
export type CreateSessionMutationVariables = Types.Exact<{
  input: Types.CreateSessionInput;
}>;


export type CreateSessionMutation = { __typename?: 'Mutation', createSession: { __typename?: 'Session', id: string, channel: string, created: any, endTime?: any | null, duration?: number | null, internal: boolean, isWeb: boolean, patientPlatform: string, doctorPlatform: string, timezone?: number | null, lastUpdated: any, videoProvider: string, participantsCount: number, roomId: string, pidList: string, mainSessionId?: string | null, userId: string } };

export type AddSessionParticipantMutationVariables = Types.Exact<{
  input: Types.AddSessionParticipantInput;
}>;


export type AddSessionParticipantMutation = { __typename?: 'Mutation', addSessionParticipant: boolean };

export type EndSessionFromProviderMutationVariables = Types.Exact<{
  input: Types.EndSessionInput;
}>;


export type EndSessionFromProviderMutation = { __typename?: 'Mutation', endSessionFromProvider: boolean };

export type EndSessionFromPatientMutationVariables = Types.Exact<{
  input: Types.EndSessionInput;
}>;


export type EndSessionFromPatientMutation = { __typename?: 'Mutation', endSessionFromPatient: boolean };

export type SaveCallRatingFromProviderMutationVariables = Types.Exact<{
  input: Types.SaveCallRatingInput;
}>;


export type SaveCallRatingFromProviderMutation = { __typename?: 'Mutation', saveCallRatingFromProvider: boolean };

export type SaveCallRatingFromPatientMutationVariables = Types.Exact<{
  input: Types.SaveCallRatingInput;
}>;


export type SaveCallRatingFromPatientMutation = { __typename?: 'Mutation', saveCallRatingFromPatient: boolean };

export type CallHistoryQueryVariables = Types.Exact<{
  input: Types.GetCallHistoryInput;
  offset?: Types.InputMaybe<Types.Scalars['Int']['input']>;
  limit?: Types.InputMaybe<Types.Scalars['Int']['input']>;
}>;


export type CallHistoryQuery = { __typename?: 'Query', callHistory: { __typename?: 'CallHistoryOffsetConnection', edges: Array<{ __typename?: 'CallHistorySessionOffsetEdge', offset: number, node: { __typename?: 'CallHistorySession', id: string, created: string, endTime?: string | null, duration?: number | null, roomId: string, userId: string, firstName: string, lastName: string, displayName: string, slug: string } }>, pageInfo: { __typename?: 'OffsetPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, totalCount: number } } };

export type CallHistoryForCsvQueryVariables = Types.Exact<{
  input: Types.GetCallHistoryInput;
}>;


export type CallHistoryForCsvQuery = { __typename?: 'Query', callHistoryForCsv: Array<{ __typename?: 'CallHistorySessionForCsv', slug: string, startTime: string, endTime?: string | null, duration?: string | null, waitTime?: string | null, patientComments: Array<string>, patientIssues: Array<string>, patientRatings: Array<number>, providerComment?: string | null, providerIssues?: string | null, providerRating?: number | null }> };


export const CreateSessionDocument = `
    mutation CreateSession($input: CreateSessionInput!) {
  createSession(input: $input) {
    id
    channel
    created
    endTime
    duration
    internal
    isWeb
    patientPlatform
    doctorPlatform
    timezone
    lastUpdated
    videoProvider
    participantsCount
    roomId
    pidList
    mainSessionId
    userId
  }
}
    `;
export const AddSessionParticipantDocument = `
    mutation AddSessionParticipant($input: AddSessionParticipantInput!) {
  addSessionParticipant(input: $input)
}
    `;
export const EndSessionFromProviderDocument = `
    mutation EndSessionFromProvider($input: EndSessionInput!) {
  endSessionFromProvider(input: $input)
}
    `;
export const EndSessionFromPatientDocument = `
    mutation EndSessionFromPatient($input: EndSessionInput!) {
  endSessionFromPatient(input: $input)
}
    `;
export const SaveCallRatingFromProviderDocument = `
    mutation SaveCallRatingFromProvider($input: SaveCallRatingInput!) {
  saveCallRatingFromProvider(input: $input)
}
    `;
export const SaveCallRatingFromPatientDocument = `
    mutation SaveCallRatingFromPatient($input: SaveCallRatingInput!) {
  saveCallRatingFromPatient(input: $input)
}
    `;
export const CallHistoryDocument = `
    query CallHistory($input: GetCallHistoryInput!, $offset: Int, $limit: Int) {
  callHistory(input: $input, offset: $offset, limit: $limit) {
    edges {
      offset
      node {
        id
        created
        endTime
        duration
        roomId
        userId
        firstName
        lastName
        displayName
        slug
      }
    }
    pageInfo {
      hasNextPage
      hasPreviousPage
      totalCount
    }
  }
}
    `;
export const CallHistoryForCsvDocument = `
    query CallHistoryForCsv($input: GetCallHistoryInput!) {
  callHistoryForCsv(input: $input) {
    slug
    startTime
    endTime
    duration
    waitTime
    patientComments
    patientIssues
    patientRatings
    providerComment
    providerIssues
    providerRating
  }
}
    `;

const injectedRtkApi = graphQlService.injectEndpoints({
  endpoints: (build) => ({
    CreateSession: build.mutation<CreateSessionMutation, CreateSessionMutationVariables>({
      query: (variables) => ({ document: CreateSessionDocument, variables })
    }),
    AddSessionParticipant: build.mutation<AddSessionParticipantMutation, AddSessionParticipantMutationVariables>({
      query: (variables) => ({ document: AddSessionParticipantDocument, variables })
    }),
    EndSessionFromProvider: build.mutation<EndSessionFromProviderMutation, EndSessionFromProviderMutationVariables>({
      query: (variables) => ({ document: EndSessionFromProviderDocument, variables })
    }),
    EndSessionFromPatient: build.mutation<EndSessionFromPatientMutation, EndSessionFromPatientMutationVariables>({
      query: (variables) => ({ document: EndSessionFromPatientDocument, variables })
    }),
    SaveCallRatingFromProvider: build.mutation<SaveCallRatingFromProviderMutation, SaveCallRatingFromProviderMutationVariables>({
      query: (variables) => ({ document: SaveCallRatingFromProviderDocument, variables })
    }),
    SaveCallRatingFromPatient: build.mutation<SaveCallRatingFromPatientMutation, SaveCallRatingFromPatientMutationVariables>({
      query: (variables) => ({ document: SaveCallRatingFromPatientDocument, variables })
    }),
    CallHistory: build.query<CallHistoryQuery, CallHistoryQueryVariables>({
      query: (variables) => ({ document: CallHistoryDocument, variables })
    }),
    CallHistoryForCsv: build.query<CallHistoryForCsvQuery, CallHistoryForCsvQueryVariables>({
      query: (variables) => ({ document: CallHistoryForCsvDocument, variables })
    }),
  }),
});

export { injectedRtkApi as api };
export const { useCreateSessionMutation, useAddSessionParticipantMutation, useEndSessionFromProviderMutation, useEndSessionFromPatientMutation, useSaveCallRatingFromProviderMutation, useSaveCallRatingFromPatientMutation, useCallHistoryQuery, useLazyCallHistoryQuery, useCallHistoryForCsvQuery, useLazyCallHistoryForCsvQuery } = injectedRtkApi;

